<template>

<!-- App.vue -->

<v-app>
    <div v-if="!storeState.gotUsageReport">
      <template>
        <div class="tw-flex tw-justify-center">
          <div class="tw-pt-32">
 <v-progress-circular
      :rotate="360"
      :size="100"
      :width="15"
      :value="value"
      color="green"
      :indeterminate="type"
    >
      {{ value }}
    </v-progress-circular>
          </div>
        </div>
        
      </template>
    </div>
   <div v-else-if="storeState.gotUsageReport && storeState.usageReport.length > 0">  
     
  <v-app-bar app>
      <h2> Usage Report for <b> {{storeState.user_domain}} </b> </h2>
  </v-app-bar>

  <!-- Sizes your content based upon application components -->
 

    <!-- Provides the application the proper gutter -->
    <v-container>
        <v-content>

    <v-row>
          <v-col>
              <b>Your Monthly Runs:</b> <br>{{parseInt(storeState.monthlyRuns).toLocaleString("en-US")}}
          </v-col>
    </v-row>
    <br>

    <v-card>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="storeState.usageReport"
      :search="search"
      :items-per-page="15"
    >
        <template #item.name="{ item }">
        <a :href="item.link" target="_blank">
          {{ item.name }}
        </a>
    </template>

    </v-data-table>
  </v-card>
  </v-content>
     
    </v-container>


  <v-footer app>
    <!-- -->
  </v-footer>
   </div>
</v-app>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import debounce from 'debounce'
import { store } from '../store.js';
import _ from 'lodash';

document.body.setAttribute('data-app', true)

export default {
  mounted() {
    document.title="Seekwell Report"
  },
  created() {
    this.storeState.block = JSON.parse(JSON.stringify(this.storeState.blockTemplate))
  },
  data() {
    return {
      interval: {},
      value: 0,
      progressColor: 'green',
      type: false,
      store: store,
      storeState: store.state,
      search: '',
      headers: [
          {
            text: 'Block', value: 'name',  align: 'start'},
          { text: 'Created By', value: 'user_email' },
          { text: 'Period', value: 'period' },
          { text: 'Monthly Runs', value: 'monthly_runs' },
          { text: 'Created On', value: 'created_on' },
          { text: 'Updated On', value: 'updated_on' },
      ]
      
     
    };
  },
mounted () {
      this.interval = setInterval(() => {
        if (this.value === 100  ) {
          return (this.type = true)
        }
        this.value += 2
      }, 1000)
    },
}
</script>

